// extracted by mini-css-extract-plugin
module.exports = {"popup-timer-container":"overlayWithTimer_popup-timer-container__20z9E","popup-timer-border":"overlayWithTimer_popup-timer-border__2ijHL"};